import React, { cloneElement, type ReactElement } from "react";
import { twMerge } from "tailwind-merge";

export interface AssetProps {
  logo: string | ReactElement;
  alt?: string;
  className?: string;
  size?: "xl" | "lg" | "md" | "sm" | "xs";
}

const sizes = {
  xl: "h-8 w-8",
  lg: "h-6 w-6",
  md: "h-5 w-5",
  sm: "h-4 w-4",
  xs: "h-3 w-3",
} as const;

export function SupAsset({ logo, alt, className, size = "lg" }: AssetProps) {
  return (<span className={twMerge("sup-asset inline-flex rounded-full overflow-hidden", sizes[size], className)}>
      {typeof logo === "string" ?
       <img src={logo} alt={alt} className="object-cover object-center" /> :
        // @ts-ignore
       cloneElement(logo, { alt, className: twMerge(logo.props.className, "object-cover object-center") })}
    </span>);
}
